import { useEffect } from 'react'

const ASSETS_TO_PRELOAD = [
    '/bg-start.jpg',
    '/bg-char.jpg',
    '/bg-clean.jpg',
    '/bg-fight.jpg',
    '/appicon.png',
    '/logo.png',
    '/logo-breit.png',
    '/oma-avatar.png',
    '/rookie.png',
    '/ritter.png',
    '/magier.png',
    '/king.png',
    '/stadt/citybg.jpg',
    '/stadt/rathaus1.png',
    '/stadt/goldmine1.png',
    '/stadt/kaserne1.png',
    '/stadt/lager1.png',
    '/kampf/bg-stufe1.jpg',
    '/kampf/bg-stufe2.jpg',
    '/kampf/bg-stufe3.jpg',
    '/kampf/bg-stufe4.jpg',
    '/kampf/bg-stufe5.jpg',
]

export function Preloader() {
    useEffect(() => {
        // Run preloading in background with low priority if possible, but here just standard
        const preloadImage = (src: string) => {
            const img = new Image()
            img.src = src
        }

        ASSETS_TO_PRELOAD.forEach(src => {
            preloadImage(src)
        })

        console.log(`[Preloader] Started preloading ${ASSETS_TO_PRELOAD.length} assets.`)
    }, [])

    return null
}
